import { Dispatch, AnyAction } from 'redux';
import { feedActions } from './feedSlice';
import { feedService } from '../../services/feedService';
import { openMessageModal } from '../../components/statusModal/messageModalActionCreators';
import { FeedFilters } from '../../models/feed';

// Load news posts
export const loadNewsPosts = (page: number = 1, pageSize: number = 20, filters?: FeedFilters) =>
    async (dispatch: Dispatch) => {
        try {
            dispatch(feedActions.setNewsLoading(true));
            const response = await feedService.getPosts('news', page, pageSize, filters);
            dispatch(feedActions.setNewsPosts(response));
        } catch (error) {
            console.error('Error loading news:', error);
            dispatch(openMessageModal('Failed to load news', 'error') as unknown as AnyAction);
        } finally {
            dispatch(feedActions.setNewsLoading(false));
        }
    };

// Load events posts
export const loadEventsPosts = (page: number = 1, pageSize: number = 20, filters?: FeedFilters) =>
    async (dispatch: Dispatch) => {
        try {
            dispatch(feedActions.setEventsLoading(true));
            const response = await feedService.getPosts('event', page, pageSize, filters);
            dispatch(feedActions.setEventsPosts(response));
        } catch (error) {
            console.error('Error loading events:', error);
            dispatch(openMessageModal('Failed to load events', 'error') as unknown as AnyAction);
        } finally {
            dispatch(feedActions.setEventsLoading(false));
        }
    };

// Load post detail
export const loadPostDetail = (id: string) => async (dispatch: Dispatch) => {
    try {
        dispatch(feedActions.setDetailLoading(true));
        const [post, relatedPosts] = await Promise.all([
            feedService.getPostById(id),
            feedService.getRelatedPosts(id, 3),
        ]);
        dispatch(feedActions.setCurrentPost(post));
        dispatch(feedActions.setRelatedPosts(relatedPosts));
    } catch (error) {
        console.error('Error loading post detail:', error);
        dispatch(openMessageModal('Failed to load post', 'error') as unknown as AnyAction);
    } finally {
        dispatch(feedActions.setDetailLoading(false));
    }
};

// Load categories
export const loadCategories = () => async (dispatch: Dispatch) => {
    try {
        const categories = await feedService.getCategories();
        dispatch(feedActions.setCategories(categories));
    } catch (error) {
        console.error('Error loading categories:', error);
    }
};

// Load sources
export const loadSources = () => async (dispatch: Dispatch) => {
    try {
        const sources = await feedService.getSources();
        dispatch(feedActions.setSources(sources));
    } catch (error) {
        console.error('Error loading sources:', error);
    }
};

// Update filters
export const updateFilters = (filters: FeedFilters) => (dispatch: Dispatch) => {
    dispatch(feedActions.setActiveFilters(filters));
};

// Clear filters
export const clearFilters = () => (dispatch: Dispatch) => {
    dispatch(feedActions.clearActiveFilters());
};
